'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _CloseSmall;
var _excluded = ["className", "variant", "onClose", "children", "disabled"];
import * as React from 'react';
import { useState } from 'react';
import CloseSmall from '@crehana/compass.icons.outline/CloseSmall';
import { cn } from "../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Chip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'choices' : _ref$variant,
    onClose = _ref.onClose,
    children = _ref.children,
    disabled = _ref.disabled,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    closed = _useState2[0],
    setClosed = _useState2[1];
  if (closed) return null;
  var handleClose = function handleClose() {
    setClosed(true);
    if (onClose) onClose();
  };
  return variant === 'choices' ? /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    ref: ref,
    className: cn('tw-group tw-font-body5 tw-border-solid tw-inline-flex tw-h-3.6 tw-items-center tw-gap-0.8 tw-rounded-2 tw-border tw-px-1.2 tw-transition-colors', disabled ? 'tw-pointer-events-none tw-border-neutral-light-400 tw-bg-neutral-light-400 tw-text-neutral-light-600 dark:tw-bg-neutral-dark-500 dark:tw-border-neutral-dark-500 dark:tw-text-neutral-dark-600' : 'tw-text-neutral-light-700 tw-cursor-pointer tw-border-neutral-light-600 hover:tw-border-primary-light-400 hover:tw-text-primary-light-400 active:tw-bg-primary-light-400 active:tw-text-neutral-light-100 dark:tw-border-neutral-dark-500 dark:tw-text-neutral-dark-500 dark:hover:tw-border-secondary-dark-300 hover:dark:tw-text-secondary-dark-300 dark:active:tw-bg-secondary-dark-300 dark:active:tw-text-neutral-dark-800', className)
  }, props), {}, {
    children: children
  })) : /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    ref: ref,
    className: cn('tw-group tw-font-body5 tw-border-solid tw-inline-flex tw-h-3.6 tw-items-center tw-gap-0.8 tw-rounded-2 tw-border tw-px-1.2 tw-transition-colors', disabled ? 'tw-pointer-events-none tw-border-neutral-light-400 tw-bg-neutral-light-400 tw-text-neutral-light-600 dark:tw-bg-neutral-dark-500 dark:tw-border-neutral-dark-500 dark:tw-text-neutral-dark-600' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500 tw-border-neutral-light-600 dark:tw-border-neutral-dark-500 dark:hover:tw-text-neutral-light-100 dark:hover:tw-border-neutral-light-100', className)
  }, props), {}, {
    children: [children, variant === 'close' ? /*#__PURE__*/_jsx("button", {
      disabled: disabled,
      className: "tw-rounded-full tw-bg-transparent tw-p-[2px] tw-text-neutral-light-700 tw-transition-all disabled:tw-text-neutral-light-600 group-hover:tw-bg-primary-light-500 group-hover:dark:tw-bg-secondary-dark-300 group-hover:tw-text-neutral-light-100 group-active:tw-bg-primary-light-400 dark:tw-text-neutral-dark-500 group-hover:dark:tw-text-neutral-light-800 group-active:dark:tw-bg-secondary-dark-300 group-active:dark:tw-text-neutral-light-100 tw-flex tw-items-center disabled:dark:tw-text-neutral-dark-600",
      onClick: handleClose,
      children: _CloseSmall || (_CloseSmall = /*#__PURE__*/_jsx(CloseSmall, {
        className: "tw-text-inherit",
        size: 16
      }))
    }) : null]
  }));
});
export { Chip };